import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@elaniintc/goes-design-system";
import React from "react";

interface OptionTooltipProps {
  children: React.ReactNode;
  title: string;
  defaultOpen?: boolean;
  onChange?: (open: boolean) => void;
  danger?: boolean;
}

export const OptionTooltip: React.FC<OptionTooltipProps> = ({
  children,
  title,
  defaultOpen = false,
  onChange,
}) => {
  return (
    <Tooltip
      {...(defaultOpen ? { open: defaultOpen } : {})}
      delayDuration={0}
      {...(onChange ? { onOpenChange: onChange } : {})}
    >
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side="top" align="center">
        {title}
      </TooltipContent>
    </Tooltip>
  );
};
